import { PlayerProfileResponse } from 'protos'

const flatMapTimelineSegments = (
  timeline: PlayerProfileResponse.TimelinePoint[],
  fn: (
    value: {
      prev: PlayerProfileResponse.TimelinePoint,
      curr: PlayerProfileResponse.TimelinePoint,
    },
    index?: number,
  ) => JSX.Element[],
) => {
  return timeline.reduce(({ prev, acc }, curr, i) => {
    if (prev !== undefined) {
      acc.push(...fn({ prev, curr }, i))
    }

    return {
      prev: curr,
      acc,
    }
  }, {
    prev: undefined as PlayerProfileResponse.TimelinePoint | undefined,
    acc: [] as JSX.Element[],
  }).acc
}

export default flatMapTimelineSegments
